import React from 'react';
import { Link } from 'react-router-dom';
import Layout from '../components/Layout';
import { useAuth } from '../context/AuthContext';
import { useLanguage } from '../context/LanguageContext';
import { PageContainer, Button, Card } from '../components/ui';

function ShieldIcon() {
  return (
    <svg
      className="w-24 h-24 sm:w-28 sm:h-28 text-[#0ea5e9]/20 dark:text-[#0ea5e9]/30"
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      aria-hidden
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
        d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"
      />
    </svg>
  );
}

export default function Home() {
  const { user } = useAuth();
  const { t } = useLanguage();

  return (
    <Layout>
      <div className="min-h-[80vh] flex items-center justify-center bg-[#f8fafc] dark:bg-slate-900">
        <PageContainer className="py-12 flex items-center justify-center">
          <Card className="w-full max-w-lg p-8 sm:p-10 flex flex-col items-center text-center gap-6">
            <h1 className="text-[32px] font-bold text-[#0f172a] dark:text-slate-100 tracking-tight leading-tight">
              {t.welcome}
            </h1>
            <p className="text-[#475569] dark:text-slate-400 text-base max-w-[500px] mx-auto leading-relaxed">
              {t.welcomeDesc}
            </p>
            <div className="flex flex-col items-center gap-6">
              {user?.organizationId ? (
                <Link to={`/org/${user.organizationId}/dashboard`}>
                  <Button
                    variant="primary"
                    className="px-7 py-3.5 text-base font-semibold rounded-[10px] hover:bg-[#0284c7] transition-colors duration-200"
                  >
                    {t.accessDashboard}
                  </Button>
                </Link>
              ) : (
                <Link to="/organizations/new">
                  <Button
                    variant="primary"
                    className="px-7 py-3.5 text-base font-semibold rounded-[10px] hover:bg-[#0284c7] transition-colors duration-200"
                  >
                    {t.createOrganization}
                  </Button>
                </Link>
              )}
              <ShieldIcon />
            </div>
          </Card>
        </PageContainer>
      </div>
    </Layout>
  );
}
